import { TripType } from '@/shared/functions/Flights/flights.types'

import { Country, Leg } from '../../redux/states/flights/getAllFlightItineraries/getAllFlightItineraries.types'

export const getFormattedTripDetails = (legs: Leg[], tripType: TripType): string => {
  const firstLeg = legs[0]
  let tripDetails = ''

  switch (tripType) {
    case 'oneWay':
      tripDetails = `${firstLeg.origin.airport.iataCode} → ${firstLeg.destination.airport.iataCode}`
      break

    case 'roundTrip':
      tripDetails = `${firstLeg.origin.airport.iataCode} ⇌ ${firstLeg.destination.airport.iataCode}`
      break

    case 'multiCity':
      tripDetails = legs
        .map((leg) => `${leg.origin.airport.iataCode} → ${leg.destination.airport.iataCode}`)
        .join('\u00A0 • \u00A0')
      break
  }

  return tripDetails
}

/**
 * Get the marketplace country associated with the items in a flight itinerary
 * @param legs - The legs of the flight
 * @returns The marketplace country associated with the items
 */
export const getMarketplaceCountryAssociatedWithItems = (legs: Leg[]) => {
  const countries = new Set<Country>()

  legs.forEach((leg) => {
    leg.offerRequestsDetails.forEach((offerRequest) => {
      offerRequest.itemRequestDetails.forEach((itemRequest) => {
        if (itemRequest.item.country && !countries.has(itemRequest.item.country)) {
          countries.add(itemRequest.item.country)
        }
      })
    })
  })

  return Array.from(countries)[0]
}
